import { Card, CardBody, Col } from "reactstrap";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WithIndicator } from "../../../../Constant";
import { WITH_INDICATOR, WITH_INDICATOR_DATA } from "../../../../Data/Bonus Ui/Carousel";

const WithIndicators = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={WithIndicator} span={WITH_INDICATOR} />
        <CardBody>
          <Swiper pagination={{ clickable: true }} navigation modules={[Pagination, Navigation]}>
            {WITH_INDICATOR_DATA.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={item.image} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithIndicators;
